import { FloatingArrow, type FloatingContext } from '@floating-ui/react';
import { createContext } from 'react';
import { type ContextValue, useContextProps } from 'react-aria-components';

import { assert } from '@gitbook/util-ts';

export type PopoverArrowProps = {
    context?: FloatingContext;
};

export const PopoverArrowContext = createContext<ContextValue<PopoverArrowProps, SVGSVGElement>>(
    {}
);

/**
 * Arrow element to be used within a Popover.
 */
export function PopoverArrow({
    ref,
    ...props
}: PopoverArrowProps & { ref?: React.ForwardedRef<SVGSVGElement> }) {
    [props, ref] = useContextProps(props, ref, PopoverArrowContext);
    assert(props.context, 'PopoverArrow must be used within a Popover');
    return <FloatingArrow ref={ref} className="z-[1] fill-base" context={props.context} />;
}
